// modules
import MAC from './mac.directive';

export default angular.module( 'app.components.validators.module',
	[
		MAC
	])

	.name;





/** WEBPACK FOOTER **
 ** ./src/components/formValidators/index.js
 **/